var _clipPath, _g, _clipPath2, _g2, _clipPath3, _g3, _clipPath4, _g4, _image, _image2, _image3, _image4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlasvordachFreitragend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 800 600",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    space: "preserve",
    serif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Glasvordach freitragend",
    transform: "matrix(1,0,0,1,0,65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "T\\xFCr",
    transform: "matrix(1.0461,0,0,1.2183,102.979,-141.253)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.78257e-17,1.00168,-1.45151,1.52412e-17,462.458,434.239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-89.648,118.49L120.636,118.49L120.636,89.648L-92.803,89.648L-89.648,118.49Z",
    style: {
      fill: "rgb(179,178,178)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.45151,1.9789e-17,-2.31447e-17,-1.08937,39.7616,298.105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-235.891L172.722,-235.891L172.742,-35.742L0,0.243L0,-235.891Z",
    style: {
      fill: "rgb(112,111,111)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.68021e-17,1.76771,-1.45151,-3.14662e-17,210.757,136.983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.759,117.805L91.178,117.806L117.805,-54.917L115.659,-83.759L83.759,117.805Z",
    style: {
      fill: "rgb(135,135,135)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freitragend",
    transform: "matrix(2.58495,0,0,3.01049,-6.75501,-3.88272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dura_x5F_Plus"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,40.8C28,40.8 21.3,45 9.6,47.5L9.6,32.7C22,32.7 28,34.1 28,34.1L28,40.8Z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.386854,-0,-0,0.332172,2.6132,-20.3015)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image2",
    x: 18.226,
    y: 161.153,
    width: "47.563px",
    height: "44.555px",
    transform: "matrix(0.990899,0,0,0.990116,0,0)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M9.6,47.5C21.3,45 28,40.8 28,40.8L28,34.1L28.4,34.4L28.4,41.1C28.4,41.1 21.7,45.3 10,47.8L9.6,47.5Z",
    style: {
      fill: "rgb(135,135,135)",
      fillRule: "nonzero"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.6,89.5L9.9,47.7C21.6,45.2 28.3,41 28.3,41L227,85.5C227,85.5 222.5,87.9 214.6,89.5Z",
    clipRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.386854,-0,-0,0.332172,2.6132,-20.3015)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image4",
    x: 18.863,
    y: 185.8,
    width: "561.194px",
    height: "146.009px",
    transform: "matrix(0.998565,0,0,0.993256,0,0)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M28.4,34.3L227,80.9L227,85.5L28.4,41.1L28.4,34.3Z",
    style: {
      fill: "url(#_Linear5)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.9,83.3L29.8,38.6L29.8,37.3L225.9,82.1L225.9,83.3Z",
    style: {
      fill: "rgb(135,135,135)",
      fillRule: "nonzero"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5,36C24.5,36.6 24.9,37 25.3,37C25.7,37 26.1,36.5 26.1,35.9C26.1,35.3 25.7,34.9 25.3,34.9C24.8,34.9 24.5,35.4 24.5,36Z",
    clipRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.386854,-0,-0,0.332172,2.6132,-20.3015)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image7",
    x: 68.396,
    y: 184.005,
    width: "4.136px",
    height: "6.322px",
    transform: "matrix(0.827185,0,0,0.903146,0,0)"
  })))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5,39.7C24.5,40.3 24.9,40.7 25.3,40.7C25.7,40.7 26.1,40.2 26.1,39.6C26.1,39 25.7,38.6 25.3,38.6C24.8,38.7 24.5,39.2 24.5,39.7Z",
    clipRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.386854,-0,-0,0.332172,2.6132,-20.3015)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image9",
    x: 68.396,
    y: 196.338,
    width: "4.136px",
    height: "6.322px",
    transform: "matrix(0.827185,0,0,0.903146,0,0)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M128.3,29.8L303.6,79.8L303.6,78.5L128.3,28.6L128.3,29.8Z",
    style: {
      fill: "rgb(139,186,211)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.8,37.3L29.8,38.6L128.3,29.8L128.3,28.6L29.8,37.3Z",
    style: {
      fill: "rgb(65,138,168)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.9,82.1L225.9,83.3L303.6,79.8L303.6,78.5L225.9,82.1Z",
    style: {
      fill: "rgb(177,198,209)",
      fillOpacity: 0.3,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.6,79.8L225.9,83.3L29.8,38.6L128.3,29.8L303.6,79.8Z",
    style: {
      fill: "url(#_Linear10)",
      fillRule: "nonzero"
    }
  }))))), /*#__PURE__*/React.createElement("defs", null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "_Image2",
    width: "48px",
    height: "45px",
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAUDBAQEAwUEBAQFBQUGBwwIBwcHBw8LCwkMEQ8SEhEPERETFhwXExQaFRERGCEYGh0dHx8fExciJCIeJBweHx7/2wBDAQUFBQcGBw4ICA4eFBEUHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh7/wAARCAAtADADAREAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABAYH/8QAFxAAAwEAAAAAAAAAAAAAAAAAAAIDAf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwDfJuAmbgKm4CZuAmbgJm4EVNwEzcBM3ATNwEzcBM3AipuAmbgJm4CZuAmbgJm4EVNwEzcBM3ATNwEzcBM3AipuAmbgJm4CZuAqbgJm4EVJtATNtATNtATNtAVNtATNtA//2Q=="
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "_Image4",
    width: "562px",
    height: "147px",
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAUDBAQEAwUEBAQFBQUGBwwIBwcHBw8LCwkMEQ8SEhEPERETFhwXExQaFRERGCEYGh0dHx8fExciJCIeJBweHx7/2wBDAQUFBQcGBw4ICA4eFBEUHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh7/wAARCACTAjIDAREAAhEBAxEB/8QAGgABAQEBAQEBAAAAAAAAAAAAAAQDAgEHBv/EACcQAQACAgICAgICAgMAAAAAAAABAgMEMWERITJBElJRoRQjInGB/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAwDAQACEQMRAD8A+yYt3tBVi3e1FWLd7BTj3fP2CimzSQaVyUniQdx7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8ux7sxzKCnHu9gqxbvYKsW7x7BVi3ewU4t3tRVi3ewVY92J5kG9Nikg0res8SDoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHzXJp0tx4BPfStX3XzCQZTjz04nyD2ufLT5RINse72CrHu9gqxbvYKcW72CrFvcewVYt7tRVi3ewU49yJ5BtXYpINIvWeJB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD5+ADyaxPMQDO2DHb6Bhk0qzx4SDC+nevxmYBnNc9Owe12clPlEwDfHu9gqxbvYKsW72CrFu9gqxbvYKcW7x7UVYt3sFOPcieQbVz0n7BpFqzxMA9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8/AAAAAB5NazzEAyvr47fQMMmlWePCDC+pkr8ZkHH++nYOqbV6/KJgFGLd7BVi3ewU493sFWLd7BVi3ewVYt3tRVi3ewUU26zyDauak/YO4mJ4kHoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPn4AAAAAAAAAOZpWeYgGd9bHb6BPk0YnhBhbVy04mQc/lnpzHkHdNu1fl5gFGLd7BVi3ewVYt3sFWLd7BVi3ewU4t3tRVi3ePYKKbVZ5BrXLS32DuJieJB6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD5+AAAAAAAAAAAAADm2Ok81gGV9XHYE+TR/hIMLa+WnEyDz881OYkGlNy0c+YBTi3ePYKcW72CrFu9gqx7vYKsW72CrFu9qKce75+wUU2qTyDWuSk/YO4mJ4kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHz8AAAAAAAAAAAAAAAAAHFsdLc1BlfUpbgE+TR+6/wBJBjbBmpxMg8jLmpzEg1x7kxPufAKcW7x7BVi3uPYKsW72CrHu9gpxbvYKsW72oqx7sTzIN6bNLA1rkpPEg6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8/AAAAAAAAAAAAAAAAAAAAAmInmAcWxUtzAMMmnS3AML6Mx8fP8A4kGM4s1OJ8g9jNlpzEg1x7sxzIKsW72CnFvcewVYt3sFWLd7BVi3ewVY93tRTj3InmQb02KWBpW9Z4kHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPn4AAAAAAAAAAAAAAAAAAAAAAAAPJiJ5gHFsOO30DDJp0tx4BhfStX4+YSDKaZ6dg9rsZKfKJBtj3ewVYt3sFWLd7BVi3ePYKcW72CrFu9gqxbvainHuRPPgG9c9LA0i1Z4kHoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPn4AAAAAAAAAAAAAAAAAAAAAAAAAAAAPJrE8xAM74MdvoGGTSrPHhBhfTvX4zMEGc1z07B1XZyV+UTAN8e72CrFu9gpxbvYKsW9x7BVi3uPYKsW72oqxbvYKKbdZ58A2rnpb7BpFqzxMA9AAAAAAAAAAAAAAAAAAAAAAAAAB8/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB5NazzEAyvr47fQMMmlWeEGF9TJT4zIOP99PryDqm1evMTAKMW72CrHu9gqxbvYKsW72CnFu9gqxb3HtRVj3ewUU26zz4BtXNSfsHcTE8SD0AAAAAAAAAAAAAAAAAAAAAHz8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHM0rPMQDK+tjt9AwyaMT7hIMLa2WnEyDn8s9J9x5B3TbtXnzAKcW72CnHu9gqxbvYKsW72CrFvdgqxb3HtRTj3ewUU2qzyDauWk/YOomJ4kHoAAAAAAAAAAAAAAAAAPn4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAObY6W5rAMb6uOwMMmj+v9JBhbXzU4mQeRfNTmJBpTcmOfMApxbvYKsW72CrFu9gpx7vYKsW72CrFu9qKse7/ADIN6bVJ5BrXJSfsHcTE8AAAAAAAAAAAAAAA+fgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAT7BxbFS3NQY31KW4BPk0Zj4/0kGVsOanEyDyMuanMSDXHuzHM+AU4t3sFWLd7BVj3ewVYt3sFWLd7BVi3e1FOPdieZBvTZpINa5KTxIOgAAAAAAAAAAfPwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJiJ5gGdsNLcwDHJp0twCe+lMfHzH/AEkGU4s9OJ8g9rny05iQa493xzIKsW7x7BVi3ewU4t3sFWLd7BVj3ewVYt3tRTj3InmQb02KWBpF6zxIOgAAAAAAfPwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeTETzAOLYcdvoGGTTpbhBPfStX4zMEGc0z07B7XYyU+USDfHu9gpxb3HsFWLd7BVi3ewVYt3sFWPd7BTi3e1FOPciefAN6Z6W+waRas8SD0AAHz8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHk1rPMQDO+DHb6Bhk0qzwkE99O9fjMwDjxnp2DquzevyiYBvi3ewVYt3sFWLe49gpxbvYKsW72CrFu9qKse72Cim3WeQa/5FAfhQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAc2rWY9xAJs1KfrAJMtKfqgnmZrbxEzCDfHe37Soqx3t/Mgpx3t+0gqxXt+0gqxXt+0gqxXt6/wCUg2/O37So/9k="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(198.6,0,0,198.6,28.4,59.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(237,237,237)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(251,251,251)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(237,237,237)",
      stopOpacity: 1
    }
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    id: "_Image7",
    width: "5px",
    height: "7px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAHCAYAAADAp4fuAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAQUlEQVQImWWMQQrAQAgDJyCC/v8v+zO92d7abjcwBIYQrbWuzCQziQjcHetuACQ9bVV1yu5G0sYhgffzG5sZ/usbFUoYJs5N5dYAAAAASUVORK5CYII="
  })), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    id: "_Image9",
    width: "5px",
    height: "7px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAHCAYAAADAp4fuAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAQUlEQVQImW2LMQoAQQgDE7Qx/3+ND9PC4q5yYWEDQ8hAmJmfJEQEJMHM4FWFDUlIgnc3SF5ccuPdfa7bbzkzZyw/9VUVVn2CosEAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear10",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(273.8,0,0,273.8,29.8,56.55)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(201,232,251)",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(234,246,254)",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(201,232,251)",
      stopOpacity: 0.5
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasvordachFreitragend);
export default __webpack_public_path__ + "static/media/glasvordach_freitragend.457aff4612d71f5c3a1071b542280a01.svg";
export { ForwardRef as ReactComponent };